// src/api/dashboardApi.ts

import client from "./client";
import { ApiResponse, DashboardStats } from "../types";

export const getDashboardStats = () =>
  client.get<ApiResponse<DashboardStats>>("/admin/dashboard/stats").then((r) => r.data.content);
